import { render, staticRenderFns } from "./server.vue?vue&type=template&id=4b5a99b3"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports